import { Component } from '@angular/core';

@Component({
  selector: 'rise-brand',
  template: 'RISE&nbsp;',
  styles: [':host { font-family: inherit; font-style: italic }'],
})
export class BrandComponent {}
